var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("textarea", { attrs: { id: _vm.cHtmlID } }),
      _vm._v(" "),
      _vm.debugMode
        ? _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12" }, [
              _c("h5", [_vm._v("Markdown")]),
              _vm._v(" "),
              _c("pre", [_vm._v(_vm._s(_vm.finalMarkup))])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-6" }, [
              _c("h5", [_vm._v("HTML (browser)")]),
              _vm._v(" "),
              _c("pre", [_vm._v(_vm._s(_vm.finalHTML))])
            ]),
            _vm._v(" "),
            _vm._m(0)
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("print-help", {
        on: {
          "html-id": function($event) {
            _vm.printHelpHtmlID = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-6" }, [
      _c("h5", [_vm._v("HTML (backend)")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }